import React, { useEffect, useState } from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";

import "./DateInputField.css";

const DateInputField = (props: any) => {
  const [value, setValue] = useState<string>(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={`${props.className} DateInputField-container`}
        disableToolbar
        minDate={props.minDate && moment(props.minDate, "DD/MM/YYYY")}
        maxDate={props.maxDate && moment(props.maxDate, "DD/MM/YYYY")}
        minDateMessage={props.minDateMessage}
        maxDateMessage={props.maxDateMessage}
        variant="inline"
        format="dd/MM/yyyy"
        margin="normal"
        value={value ? moment(value, "DD/MM/YYYY") : null}
        onChange={(date, dateString) => {
          if (dateString && dateString.indexOf("_") === -1) {
            setValue(dateString);
            if (props.onChange) {
              props.onChange(dateString);
            }
          } else if (dateString === null) {
            if (props.onChange) {
              props.onChange(null);
            }
          }
        }}
        KeyboardButtonProps={{
          "aria-label": "change date"
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DateInputField;
